import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as SessionDetailsRoute } from "@app/navigation/routes/_private/sessions/$id";
import { sessionsListQueryOptions } from "@entities/session/hooks/use-sessions-list";
import { SessionPageConnector } from "@pages/sessions/session-page-connector";

export const Route = createFileRoute("/_private/sessions/")({
  component: RouteComponent,
  loader: async ({ context }) => {
    return await context.queryClient.ensureInfiniteQueryData(
      sessionsListQueryOptions({}),
    );
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const router = useRouter();

  const handleSelectSession = useCallback(
    async (id: string) => {
      await navigate({
        params: { id },
        to: SessionDetailsRoute.fullPath,
      });
    },
    [navigate],
  );

  return (
    <SessionPageConnector
      onGoBack={router.history.back}
      onSelectSession={handleSelectSession}
    />
  );
}
